module.exports = __webpack_public_path__ + "img/636901622828851220.13ebafcc.gif";